export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10944.c2cbbb48.jpg";